import { logUsage } from "owa-analytics";
import { checkMaxEventsPerSessionCount } from "owa-analytics-utils/lib/checkMaxEventsPerSessionCount";
import type { MailboxInfo } from "owa-client-types";
import { getMicrosoft365UpsellDimeConfig, getMicrosoft365UpsellMode, isMicrosoft365UpgradeMode, } from "./getMicrosoft365UpsellMode";

function getPersistentHeaderButtonTelemetryData(mailboxInfo: MailboxInfo) {
    const upsellMode = getMicrosoft365UpsellMode(mailboxInfo);
    const dimeConfig = getMicrosoft365UpsellDimeConfig(mailboxInfo);
    if (upsellMode === "hidden" || !dimeConfig) {
        return { IsUpgrade: false };
    }
    
    return {
        IsUpgrade: isMicrosoft365UpgradeMode(upsellMode),
        CmmId: dimeConfig.campaignId,
        ...(dimeConfig.featureName ? { FeatureName: dimeConfig.featureName } : undefined),
    };
}

export function logPersistentHeaderButtonShown(mailboxInfo: MailboxInfo): void {
    if (!checkMaxEventsPerSessionCount("HeaderBuyMicrosoft365ButtonShown", 1)) {
        return;
    }
    
    logUsage("HeaderBuyMicrosoft365ButtonShown", mailboxInfo, getPersistentHeaderButtonTelemetryData(mailboxInfo));
}

export function logPersistentHeaderButtonHovered(mailboxInfo: MailboxInfo): void {
    logUsage("HeaderBuyMicrosoft365ButtonHovered", mailboxInfo, getPersistentHeaderButtonTelemetryData(mailboxInfo));
}
